export const ERROR_PRODUCT_NOT_FOUND = 'FetchError:ERROR_PRODUCT_NOT_FOUND';
